import { useMutation, useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';

import type { ApiError } from '../api/client';
import { settingsApi } from '../api/endpoints';
import type { SecretItem, SecretsSaved, SecretsUpdateRequest } from '../types/api';

const KEY = ['settings', 'secrets'] as const;

export function useSecrets(): UseQueryResult<SecretItem[], ApiError> {
  return useQuery<SecretItem[], ApiError>({
    queryKey: KEY,
    queryFn: () => settingsApi.secrets(),
    staleTime: 30_000,
    retry: false,
  });
}

export function useUpdateSecrets() {
  const qc = useQueryClient();
  return useMutation<SecretsSaved, ApiError, SecretsUpdateRequest>({
    mutationFn: (payload) => settingsApi.updateSecrets(payload),
    retry: false,
    onSuccess: (result) => {
      qc.setQueryData(KEY, result.items);
    },
  });
}
